/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-22 14:31:51
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-01-14 14:30:59
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\api\doctorTeam.js
 */
//组织机构 医护团队信息

//引入接口文档
import req from '@/utils/req.js'

//医护团队禁用
export function offDisable(params) {
  return req.put(`/admin/doctor-team/${params}/disable`)
}
//医护团队启用
export function offEnable(params) {
  return req.put(`/admin/doctor-team/${params}/enable`)
}

//医护团队服务禁用
export function offServiceDisable(params) {
  return req.put(`/admin/team-service/${params}/disable`)
}
//医护团队服务启用
export function offServiceEnable(params) {
  return req.put(`/admin/team-service/${params}/enable`)
}

//医护团队信息分页查询
export function api_doctor_team_search(params) {
  return req.post('/admin/doctor-team/search', params)
}
/**医护团队详细查询 **/
export function doctorTeam(params) {
  return req.get(`/admin/doctor-team/${params}`)
}
/** 医院列表查询  **/
export function hospital(params={}) {
  return req.post(`/admin/platform/list`,params)
}
export function downHospital(params={}) {
  return req.post(`/admin/hospital/listPullDown`,params)
}
//线下机构
export function downHospitalList(params={}) {
  return req.post('/admin/hospital/list',params)
}
/** 医院列表查询  **/
export function hospitalCopy(params={}) {
  return req.post(`/admin/hospital/list`,params)
}

/**  开放科室列表查询 **/
export function openeDpartment(params) {
  return req.post(`/admin/open-department/list`, params)
}
/** 医护团队删除 **/
export function removeDoctor(params) {
  return req.delete(`/admin/doctor-team/${params}`)
}
/** 医护团队成员删除 **/
export function removeInfo(params) {
  return req.delete(`/admin/doctor-team-member/${params}`)
}
/** 医护团队更新 **/
export function updateDoctorTeam(params) {
  return req.put(`/admin/doctor-team`, params)
}
/** 设置领衔医生 **/
export function setAsLeader(params) {
  return req.put(`/admin/doctor-team-member/setAsLeader/${params}`)
}
/** 设置护士长 **/
export function setAsMatron(params) {
  return req.put(`/admin/doctor-team-member/setAsMatron/${params}`)
}

/**医护团队添加 */
export function addDoctorTime(params) {
  return req.post(`/admin/doctor-team`, params)
}

/** 医护人员分页查询 */
export function addDoctorsearch(params) {
  return req.post(`/admin/doctor/search`, params)
}
/** 医护团队成员添加 **/
export function addDoctorPush(params) {
  return req.post(`/admin/doctor-team-member`, params)
}
// 部门树查询
export function treeList(params) {
  return req.post(`/admin/department/tree-list`, params)
}
export function treeListNew(params) {
  return req.post(`/admin/department/tree-list-member`, params)
}

/**
 *
 * 医护团队模块
 *
 */

/**医护团队服务删除 */
export function removeService(params) {
  return req.delete(`/admin/team-service/${params}`)
}
/**医护团队服务更新 */
export function upDateTeamServive(params) {
  return req.put(`/admin/team-service`, params)
}
/**医护团队服务添加 */
export function postTeamServive(params) {
  return req.post(`/admin/team-service`, params)
}
/**方案列表查询 */
export function schemePage(params) {
  return req.get(`/admin/scheme/page`, params)
}
/** 疾病类型列表查询 */

export function diseaseType(params) {
  return req.get(`/admin/disease-type`, params)
}

/**医生团队二维码添加 */
export function postDoctorTeamQrcode(params) {
  return req.post(`/admin/doctor-team-qrcode`, params)
}
/**医生团队二维码更新 */
export function upDateDoctorTeamQrcode(params) {
  return req.put(`/admin/doctor-team-qrcode`, params)
}
/**医生团队二维码删除 */
export function removeDoctorTeamQrcode(params) {
  return req.delete(`/admin/doctor-team-qrcode/${params}`)
}
//平台医院列表查询
export function platform(params) {
  return req.post(`/admin/platform/list`,params)
}
//线下机构
export function getHospitalList(params) {
  return req.post(`/admin/hospital/list`,params)
}
//开票
export function setInvoice(params) {
  return req.post(`/admin/order-drug-detail/setInvoiceInfo?isInvoice=${params.isInvoice}&&orderId=${params.orderId}`,params)
}

// 团队已配置病种 /admin/focusFieldConfig/doctorTeam/list/{teamId}
export function focusFieldConfig(teamId) {
  return req.get(`/admin/focusFieldConfig/doctorTeam/list/${teamId}`)
}

// ————————医护团队医生案例————————
//医护团队案例配置表添加
export function addInstanceData(params) {
  return req.post(`/admin/doctor-team-case-config`,params)
}
//医护团队案例配置表更新
export function updateInstanceData(params) {
  return req.put(`/admin/doctor-team-case-config`,params)
}
//医护团队案例配置表删除
export function delInstanceData(params) {
  return req.delete(`/admin/doctor-team-case-config/${params}`)
}
//通过团队ID获取配置信息
export function getInstanceData(id) {
  return req.get(`/admin/doctor-team-case-config/listByDoctorTeamId/${id}`)
}
//上移
export function moveUpInstance(id) {
  return req.post(`/admin/doctor-team-case-config/${id}/moveUp`)
}
//下移
export function moveDownInstance(id) {
  return req.post(`/admin/doctor-team-case-config/${id}/moveDown`)
}